import clsx from "clsx";
import { FaGooglePay } from "react-icons/fa";

type Props = {
  isChecked?: boolean;
  onChange: any;
};

const PayWithGoogle: React.FC<Props> = ({
  isChecked,
  onChange: handleModeChange,
}) => {
  return (
    <>
      <div
        className={clsx(
          "choose_payment_method_colm card mb-2",
          isChecked && "payment-method-active",
        )}
      >
        <div className="card_viza card_viza2">
          <label>
            <span>
              <input
                id="pay_with_google"
                type="radio"
                name="payment_mode"
                checked={isChecked}
                onChange={handleModeChange}
              />{" "}
              Google Pay{" "}
            </span>
            <FaGooglePay size={32} />
          </label>
        </div>
      </div>
    </>
  );
};

export default PayWithGoogle;
